import React from 'react';
import './Footer.css';
import { Button, Link } from '@mui/material';
import { useHistory } from 'react-router-dom';



// This is one of our simplest components
// It doesn't have local state, so it can be a function component.
// It doesn't dispatch any redux actions or display any part of redux state
// or even care what the redux state is, so it doesn't need 'connect()'

function Footer() {
  const history = useHistory();
  const sendToGithub = () => {
    window.open('https://github.com/blakesmithmn')
  }
  return <footer>
    <Button onClick={sendToGithub} sx={{ color: 'white' }}>
      &copy;  Blake Smith
    </Button>
  </footer>;
}

export default Footer;
